<template>
  <section style="width: 80vw; z-index: 5" class="mobile-svg-loader">
    <div class="mb-25">
      <vue-content-loading :width="1000" :height="450">
        <rect x="0" y="0" rx="5" ry="5" width="1000" height="450" />
      </vue-content-loading>
    </div>
    <div class="mb-0">
      <vue-content-loading :width="1000" :height="180">
        <rect x="0" y="0" rx="5" ry="5" width="1000" height="180" />
      </vue-content-loading>
    </div>
  </section>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'MobileLoading',
  components: {
    VueContentLoading,
  },
};
</script>

<style lang="scss" scoped>
section {
  display: none;
  // background: #f7f6f8;

  & .mb-25 {
    margin-bottom: 10px !important;
  }
  & .mb-0 {
    margin-bottom: 30px !important;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  section {
    display: block;
  }

  .mobile-svg-loader {
    // background: white;
    // fill-opacity: 0.5;
    fill: #eeeeee;
  }
}
</style>
